/**
 * The Weighted claims switch's two answers, and how a figure's label reads under each.
 * Its own module, free of the sign-in code, so measures and tests can use it.
 */
export type ClaimBasis = 'standard' | 'weighted'

/**
 * The basis each page opens on (Yehuda, 2026-10-06): Standard everywhere except the
 * Scorecard, whose whole point is how claims are scored, so it opens on Weighted. As
 * with Include management, opening a page puts its default back. With no rules, or
 * before the weights load, Weighted shows the standard figures anyway.
 */
export const BASIS_DEFAULT: Record<string, ClaimBasis> = { '/scorecard': 'weighted' }

export const basisDefaultFor = (path: string): ClaimBasis => BASIS_DEFAULT[path] ?? 'standard'

/**
 * A figure's label under the switch: "Billed …" reads "Weighted …" while it is on.
 * Only for figures that follow it — never "billed vs resolved", whose denominator
 * stays standard — and never for the month grids, which read standard month rows.
 */
export function basisLabel(label: string, basis: ClaimBasis): string {
  if (basis === 'standard' || /resolved/i.test(label)) return label
  return label.replace(/\bBilled\b/g, 'Weighted').replace(/\bbilled\b/g, 'weighted')
}
